import { FC } from 'react';

import Alert from 'antd/es/alert';

interface IErrorMessage {
  errorMessages: string[];
}

const ErrorMessage: FC<IErrorMessage> = ({ errorMessages = [] }) => {
  return (
    <>
      {errorMessages.map((errorMessage, index) => (
        <Alert
          key={index}
          type='warning'
          description={errorMessage}
          showIcon
          banner
        />
      ))}
    </>
  );
};

export default ErrorMessage;
